import NotificationsMailView from "../../app/angularjs/common/notifications_templates_mails/notificationsMail.html";
import PushNotificationView from "../../app/angularjs/common/push_notifications/pushNotification.html";


angular.module("app")

.factory("notificationService", ['$injector', 'logService', function ($injector, logService) {
    // modal para mandar email de notificaciones.
    /*Parametros de entrada. O directamente una lista de codigos de documents_types o pasarle los checks de true/false
     * var params = {
                entity_type: "correspondence",
                entity_type_id: $stateParams.id,
                documents: { for_correspondence: true }
            };
            var params = {
                persons_ids: [], event_staffs_ids:[],event_guests_ids:[],
                entity_type: "events",
                entity_type_id: $stateParams.id,
                mail_account_id: null,
                mail_account_reply: null,
                documents: { codes: ["PROPOSAL_GUEST_LIST", "GUEST_LIST_ADDRESSES"] }
            };
     * */

    var service = {
        notificationMail: function (options) {
            var $uibModal = $injector.get("$uibModal");
            let $modalInstance = $uibModal.open({
                animation: true,
                template: NotificationsMailView,
                controller: 'NotificationsMailCtrl',
                size: 'lg',
                resolve: {
                    options: function () { logService.debug(options); return options; }
                },
                windowClass: 'mailing-modal'
            });
            $modalInstance.result.then(function (data) {
                options.onAccept(data); //Devolvemos el control al controlador que lo invoca
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });

        },
        notificationPush: function (options) {
            var $uibModal = $injector.get("$uibModal");
            let $modalInstance = $uibModal.open({
                animation: true,
                template: PushNotificationView,
                controller: 'PushNotificationsCtrl',
                size: 'lg',
                resolve: {
                    options: function () { logService.debug(options); return options; }
                }
            });
            $modalInstance.result.then(function (data) {
                options.onAccept(data); //Devolvemos el control al controlador que lo invoca
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });
        }
    };
    return service;
}])
;